import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../../../../react-query/api';
import { endpoints } from '../../../../react-query/endpoints';

export const validModels = [
  'gpt-4o',
  'gpt-4o-2024-05-13',
  'gpt-4o-mini',
  'gpt-4o-mini-2024-07-18',
  'gpt-4-turbo',
  'gpt-4-turbo-2024-04-09',
  'gpt-4-0125-preview',
  'gpt-4-turbo-preview',
  'gpt-4-1106-preview',
  'gpt-4-vision-preview',
  'gpt-4',
  'gpt-4-0314',
  'gpt-4-0613',
  'gpt-4-32k',
  'gpt-4-32k-0314',
  'gpt-4-32k-0613',
  'gpt-3.5-turbo',
  'gpt-3.5-turbo-16k',
  'gpt-3.5-turbo-0301',
  'gpt-3.5-turbo-0613',
  'gpt-3.5-turbo-1106',
  'gpt-3.5-turbo-0125',
  'gpt-3.5-turbo-16k-0613',
] as const;

export type TGetNarrativeDev = {
  prompt: string;
  input: string;
  model: (typeof validModels)[number];
  temperature?: number | undefined;
  top_p?: number | undefined;
  frequency_penalty?: number | undefined;
  presence_penalty?: number | undefined;
};

type TGetNarrativeDevResult = {
  content: string | null;
  traceId?: string; // Backend trace ID for Langfuse linking
};

export const useGetGptResponse = (
  options?: UseMutationOptions<
    TGetNarrativeDevResult,
    AxiosError<{ message: string }>,
    TGetNarrativeDev
  >,
) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );
  const path = `/${endpoints.narrative}/${endpoints.insuranceSummaryDev}`;

  return useMutation({
    mutationFn: async (input: TGetNarrativeDev) => {
      return makeAPIRequestReactQueryWithHeaders<TGetNarrativeDevResult>(
        path,
        undefined,
        {
          Org: currentOrg,
          Practice: currentPractice,
        },
        'POST',
        {
          data: input,
        },
      );
    },
    ...options,
  });
};
